require("../sass/style.scss");

require("../../assets/fonts/fontello/css/fontello.css");


require("./vendor/bootstrap-transition");

require("./vendor/slick.min.js");
require("./vendor/jquery.cookie.js");
require("./vendor/bootstrap-collapse.js");

//require("./vendor/vue.min.js");
//require("./vendor/vue-carousel-3d.min.js");


import {TweenLite, CSSPlugin} from "gsap";
import {parallax_background} from "parallax_background";
import {parallax_content} from "parallax_content";


require("./custom/cookies.es6");
require("./custom/dynamic_viewer_of_cards.es6");
require("./custom/envision_message.es6");
require("./custom/emergent_graphic.es6");
require("./custom/process_parts.es6");
require("./custom/media_load_more.es6");
require("./custom/collections-nav.es6");
require("./custom/who_graphic.es6");
require("./custom/personal-bio-popup.es6");
require("./custom/timeline.es6");
require("./custom/leadIn.es6");
require("./custom/philantropic-partners.es6");
require("./custom/co-chairs-flex-count.es6");
require("./custom/sticky-footer.es6");
require("./custom/menu.es6");
require("./custom/search-page.es6");
require("./custom/finding-slider.es6");
require("./custom/who-tabs.es6");
require("./custom/language-link-random.es6");
require("./custom/scroll-to.es6");
require("./custom/scroll-top.es6");
require("./custom/add_voice.es6");
require("./custom/map_overview_page.es6");
require("./custom/collapse_phases.es6");
require("./custom/popup-email.es6");


(function ($) {


})(jQuery);




// WEBPACK FOOTER //
// ./src/js/entry.es6